import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_API_BASE_PROD_URL || process.env.REACT_APP_API_BASE_URL || "http://localhost:3002"; // Replace with your backend URL   

export async function fetchAllTariffCodes(practiceNumber) {
  try {
    const response = await axios.get(`${BACKEND_URL}/tariff-codes`, {
      params: { practiceNumber },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching tariff codes:", error.response?.data || error.message);
    return [];
  }
}

export async function fetchLaymansIndications(query, limit = 50) {
  try {
    if (!query || query.trim().length < 3) return [];
    const { data } = await axios.get(`${BACKEND_URL}/laymans-indications`, {
      params: { q: query.trim(), limit },
      withCredentials: true, // if you use cookies
    });
    return data || [];
  } catch (err) {
    console.error("❌ Error fetching layman's indications:", err?.response?.data || err?.message);
    return [];
  }
}


// Server-side rate resolution: overrides, contracts (place of service and
// anaesthetic rules, exclusions), networks, insured benefits, JSP/NNW/MSR.
// Returns { results: { CODE: { rate, quantity, source, ... } }, isDemoData }
// or null when the call fails, so callers keep the line's existing rate.
export async function resolveTariffRates({
  practiceNumber,
  tariffCodes,
  planOptionCode,
  serviceDate,
  placeOfService,
}) {
  try {
    const { data } = await axios.post(`${BACKEND_URL}/tariff-rates/resolve`, {
      practiceNumber,
      tariffCodes,
      planOptionCode,
      serviceDate,
      placeOfService,
    });
    return data;
  } catch (error) {
    console.error(
      "❌ Error resolving tariff rates:",
      error.response?.data || error.message
    );
    return null;
  }
}

// Contract options for the practice profile wizard (deduped price groups
// MedPrax offers for this practice's discipline on a scheme option).
export async function fetchContractOptions(practiceNumber, planOptionCode) {
  try {
    const { data } = await axios.get(`${BACKEND_URL}/tariff-contract-options`, {
      params: { practiceNumber, planOptionCode },
    });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error(
      "❌ Error fetching contract options:",
      error.response?.data || error.message
    );
    return [];
  }
}

export async function fetchAllmsrRates(
  practiceNumber,
  tariffCodes,
  planOptionCode,
  year,
  practiceContract
) {
  try {
    const response = await axios.post(
      `${BACKEND_URL}/tariffmsr`,
      { practiceNumber, tariffCodes, planOptionCode, year, practiceContract }
    );
    return response.data;
  } catch (error) {
    console.error(
      "❌ Error fetching tariff codes:",
      error.response?.data || error.message
    );
    return [];
  }
}



export async function fetchMedicalSchemesByName(searchName, category) {
  if (searchName.length < 3) return []; // Prevent API calls with less than 3 characters

  try {
    const response = await axios.get(`${BACKEND_URL}/medical-schemes`, {
      params: { searchName, category }, // ✅ Send searchName and category as query params
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching medical schemes:", error.response?.data || error.message);
    return [];
  }
}

// ✅ Fetch Plan Options and Plans by Scheme Code
export async function fetchPlanOptionsAndPlans(schemeCode) {
  if (!schemeCode) return null; // Prevent API calls if no schemeCode is provided

  try {
    const response = await axios.get(`${BACKEND_URL}/medical-schemes/${schemeCode}/plan-options`);
    return response.data; // ✅ Return array of plan options & plans
  } catch (error) {
    console.error("❌ Error fetching plan options & plans:", error.response?.data || error.message);
    return null;
  }
}


// Fetch subOptions to retrieve MediKreditCode
export async function fetchSubOptions(planOptionCode) {
  if (!planOptionCode) return [];

  try {
    const response = await axios.get(`${BACKEND_URL}/plansuboptions`, {
      params: { planOptionCode }, // ✅ Correct: send as query param
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching plan suboptions:", error.response?.data || error.message);
    return [];
  }
}

